import React from "react";
import FAQAccordion from '../FAQAccordion';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

 render() {
  return (
    <React.Fragment>
      <section id="info-high-altitude-hiking" className="about-us pt-trip gray-light-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div>
              <div className="section-heading mb-5 mx-2">
                {this.props.showTitle && this.props.showTitle === true && (
                  <span className="badge badge-primary badge-pill">
                    High Altitude Hiking
                  </span>
                )}
                <h1 className="text-center">
                  How to Train for High Altitude Hiking (Complete Beginner Guide)
                  <br />
                </h1>

                <p>
                  High altitude hiking is completely different from hiking at lower elevations.
                  As you go higher, the air gets thinner, oxygen levels drop, and your body has to work harder with every step.
                </p>

                <p>
                  Even experienced hikers can feel exhausted, short of breath, or dizzy if they are not properly prepared.
                  The good news is that you can train your body to handle high altitude conditions.
                </p>

                <p>
                  With the right preparation, you can improve your endurance, reduce the risk of altitude sickness,
                  and actually enjoy the experience instead of struggling through it.
                </p>

                <p>
                  In this guide, you will learn exactly how to train for high altitude hiking, even if you live at sea level.
                </p>

                <p>
                  If you are preparing for your next hike, check out our guide on{" "}
                  <a className="in-text-link" href="/how-to-use-hiking-poles-correctly">
                    How to Use Hiking Poles Correctly
                  </a>{" "}
                  to improve stability and reduce strain on steep terrain.
                </p>
                <FAQAccordion
                  title="High Altitude Hiking FAQs"
                  items={[
                    { q: 'What altitude is considered high for hiking?', a: 'High altitude begins at 8,000 feet (2,400m). Very high altitude is 11,500–18,000 feet. Above 18,000 feet is extreme altitude. Most popular mountain hikes in the US range from 8,000–14,400 feet.' },
                    { q: 'What are the symptoms of altitude sickness?', a: 'Early symptoms include headache, fatigue, loss of appetite, nausea, and dizziness — typically within 6–12 hours of gaining altitude. Severe altitude sickness involves shortness of breath at rest, confusion, and inability to walk in a straight line.' },
                    { q: 'How do you acclimatize before a high altitude hike?', a: 'Arrive 1–2 days early and sleep at a lower elevation than your hiking altitude. Follow "climb high, sleep low" — you can hike high during the day but descend to sleep. Stay hydrated and avoid alcohol the first few days.' },
                    { q: 'How should I train for high altitude hiking at sea level?', a: 'Build your aerobic base with running, cycling, or stair climbing. Add loaded hiking with elevation gain on local hills or a treadmill at max incline. Train consistently for 8–12 weeks. Cardio fitness reduces but does not eliminate altitude effects.' },
                    { q: 'Does Diamox help with altitude sickness?', a: 'Acetazolamide (Diamox) can speed acclimatization and prevent altitude sickness. It requires a prescription. Start 1–2 days before ascent. Common side effects include increased urination and tingling in hands and feet. Consult a doctor before use.' },
                    { q: 'How much water should you drink at high altitude?', a: 'At high altitude, you can lose water faster through increased respiration. Aim for 3–4 liters per day while hiking. Drink before you feel thirsty. Avoid alcohol and caffeine the first 24–48 hours at altitude as they accelerate dehydration.' },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
}
export default About;